import { gql } from "@apollo/client"

export const ChangePartnershipTierModalItemFragment = gql`
    fragment ChangePartnershipTierModalItemFragment on ItemType {
        id
        uuid
        formattedPrice
        recurringEnum
        collectivePass {
            id
            name
            activeJobPostLimit
            isFeatured
        }
    }
`

export const ChangePartnershipTierModalPartnershipFragment = gql`
    fragment ChangePartnershipTierModalPartnershipFragment on CollectivesSubscriptionType {
        id
        uuid
        numPosts
        isFeatured
        pallet {
            id
            slug
        }
    }
`
